(() => {
  const root = document.documentElement;
  const storageKey = 'cozienook:theme';

  const applyTheme = (mode) => {
    if (mode === 'dark') {
      root.setAttribute('data-theme', 'dark');
    } else {
      root.removeAttribute('data-theme');
    }

    document.querySelectorAll('[data-theme-toggle]').forEach((button) => {
      button.setAttribute('aria-pressed', mode === 'dark' ? 'true' : 'false');
      button.setAttribute('data-theme-current', mode);
    });
  };

  const getPreferredTheme = () => {
    try {
      const saved = localStorage.getItem(storageKey);
      if (saved === 'dark' || saved === 'light') return saved;
    } catch (error) {
    }

    return 'dark';
  };

  const setTheme = (mode) => {
    try {
      localStorage.setItem(storageKey, mode);
    } catch (error) {
    }
    applyTheme(mode);
  };

  document.addEventListener('DOMContentLoaded', () => {
    applyTheme(getPreferredTheme());

    document.querySelectorAll('[data-theme-toggle]').forEach((button) => {
      button.addEventListener('click', () => {
        const current = root.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
        setTheme(current === 'dark' ? 'light' : 'dark');
      });
    });
  });
})();
